import { gql } from '@apollo/client';

export const GET_MEMBER_APPROVAL_REQUESTS = gql`
  query MyQuery($memberId: ID!, $projectId: ID, $resourceId: ID, $skip: Int) {
    getMemberApprovalRequests(
      filter: {
        memberId: $memberId
        projectId: $projectId
        resourceId: $resourceId
      }
      pagination: { skip: $skip, take: 10 }
    ) {
      resourcesArray {
        displayName
        id
        providerId
      }
      approvalRequest {
        description
        id
        state
        type
        metadata
      }
      comment
      id
      state
      memberId
      createdAt
    }
  }
`;

export const GET_PROJECT_NAMES = gql`
  query GetProjectNames {
    getProjects {
      projectName
      id
    }
  }
`;

export const GET_MEMBERS = gql`
  query GetMembers($displayName: String!) {
    getMembers(filter: { displayName: $displayName }) {
      count
      data {
        displayName
        id
      }
    }
  }
`;

export const GET_MEMBERSS = gql`
  query GetMembers($ids: [String]) {
    getMembers(filter: { ids: $ids }) {
      data {
        providerId
        displayName
        id
      }
    }
  }
`;

export const EDIT_MEMBER_APPROVAL_REQUEST = gql`
  mutation EditMemberApprovalRequest($input: EditMemberApprovalRequestInput!) {
    editMemberApprovalRequest(input: $input)
  }
`;
